import { create, StateCreator } from "zustand"
import { DialogCustomArticle } from "./EditDialog"

export type OwnArticlesByCategorySlice = OwnArticlesByCategoryState & OwnArticlesByCategoryActions

export type ArticleListByCategorySettings = {
    initialized: boolean
    showPurchasePrice: boolean
}

type OwnArticlesByCategoryState = {
    articleListSettings: ArticleListByCategorySettings
    searchQuery: string
    articleToEdit?: DialogCustomArticle
    isSaving?: boolean
}

type OwnArticlesByCategoryActions = {
    setArticleListSettings: (articleListSettings: ArticleListByCategorySettings) => void
    setSearchQuery(query?: string): void
    setArticleToEdit(editObject?: DialogCustomArticle): void
    setIsSaving(value: boolean): void
}

const initialState: OwnArticlesByCategoryState = {
    articleListSettings: {
        initialized: false,
        showPurchasePrice: false,
    },
    searchQuery: "",
}

export const createOwnArticlesByCategoryState: StateCreator<OwnArticlesByCategorySlice, [["zustand/devtools", never]]> = (set) => ({
    ...initialState,
    setArticleListSettings: (articleListSettings) => set((state) => ({ ...state, articleListSettings })),
    setSearchQuery: (searchQuery) => set((state) => ({ ...state, searchQuery })),
    setArticleToEdit: (articleToEdit) => set((state) => ({ ...state, articleToEdit })),
    setIsSaving: (isSaving) => set((state) => ({ ...state, isSaving })),
})

export const useOwnArticlesByCategoryStore = create(createOwnArticlesByCategoryState)
